import React from 'react';
import { useSelector } from 'react-redux';
import Speaker from 'src/assets/icons/icon-speaker.svg';
import './settings-modal.scss';
import { Typography } from "src/latest/src/components";

interface TestSpeakerProps {
  audioOutputDevices: MediaDeviceInfo[];
  deviceController: any;
}

const TestSpeaker: React.FC<TestSpeakerProps> = ({
  audioOutputDevices,
  deviceController,
}) => {
  const { audioDevice } = useSelector(({ teleTherapy }: any) => teleTherapy);

  const handleTestSpeaker = async () => {
    if (!deviceController) {
      console.error('Device controller is not available');

      return;
    }

    // Get the selected audio output device
    const selectedDevice = audioOutputDevices.find(
      device => device.deviceId === audioDevice?.deviceId,
    );

    if (!selectedDevice) {
      console.error('No audio output device selected');

      return;
    }

    // Play a test sound through the selected speaker
    try {
      const audioContext = new AudioContext();
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();

      oscillator.type = 'sine';
      oscillator.frequency.value = 440; // Play a 440 Hz sine wave
      gainNode.gain.value = 0.5; // Set the volume to 50%

      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);

      // Start the oscillator
      oscillator.start();

      // Stop the oscillator after 1 second
      setTimeout(() => {
        oscillator.stop();
      }, 1000);
    } catch (error) {
      console.error('Error playing test sound:', error);
    }
  };

  return (
    <div className="speaker-icon-container" onClick={handleTestSpeaker}>
      <img src={Speaker} className="speaker-icon" alt="audio icon" />
      <Typography
        variant="size-16"
        color="color-28"
        weight="semi-bold"
        className="ms-2"
      >
        TEST SPEAKER
      </Typography>
    </div>
  );
};

export default TestSpeaker;
